import {ParticleConfig} from '@specials/particle-emitter';

export const destroyBonusConfig = (): ParticleConfig => ({
  alpha: {
    start: 1,
    end: 0,
  },
  scale: {
    start: 0.4,
    end: 0.05,
  },
  color: {
    start: '#83D2FF',
    end: '#27B1FF',
  },
  speed: {
    start: 6,
    end: 2,
  },
  direction: {
    minAngle: 0,
    maxAngle: 360,
  },
  lifeTime: {
    value: 250,
  },
});
